import React from "react";

const RefreshIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9525 8.13279H18.5285L15.6126 5.21504C14.6738 4.27625 13.5044 3.60115 12.222 3.25759C10.9396 2.91404 9.58933 2.91414 8.30697 3.25788C7.02461 3.60163 5.85534 4.27691 4.91671 5.21583C3.97808 6.15476 3.30316 7.32424 2.95981 8.6067M2.00098 17.5708V12.9948M2.00098 12.9948H6.57698M2.00098 12.9948L4.91598 15.9125C5.85475 16.8513 7.02412 17.5264 8.30653 17.87C9.58894 18.2135 10.9392 18.2134 12.2216 17.8697C13.5039 17.5259 14.6732 16.8507 15.6118 15.9117C16.5505 14.9728 17.2254 13.8033 17.5687 12.5209M18.5285 3.55679V8.13095"
      stroke="white"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RefreshButton = ({ onClick, label = "Обновить" }) => (
  <button
    onClick={onClick}
    className="bg-accent-grad flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 hover:opacity-90 hover:scale-[1.02]"
    style={{ color: "#ffffff" }}
  >
    <RefreshIcon />
    <span>{label}</span>
  </button>
);

export default RefreshButton;
